import { useState } from "react";
import { useAuth } from "@/hooks/use-auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import UserNav from "./user-nav";
import { Menu, Search, Bell, HelpCircle } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

interface HeaderProps {
  onMenuClick: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  const { user } = useAuth();
  const { toast } = useToast();
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      toast({
        title: "Search",
        description: `Search functionality would be implemented for: "${searchQuery}"`,
      });
    }
  };

  const handleNotificationsClick = () => {
    toast({
      title: "Notifications",
      description: "Notifications functionality would be implemented here",
    });
  };

  const handleHelpClick = () => {
    toast({
      title: "Help & Support",
      description: "Help and support functionality would be implemented here",
    });
  };

  return (
    <header className="bg-white border-b border-gray-200 flex items-center justify-between p-4">
      <div className="flex items-center">
        <Button
          variant="ghost"
          size="icon"
          onClick={onMenuClick}
          className="md:hidden mr-4 text-gray-600 hover:text-gray-900"
        >
          <Menu className="h-6 w-6" />
        </Button>
        {/* Universal search form - Commented out
        <form onSubmit={handleSearch} className="relative">
          <Input
            type="text"
            placeholder="Search documents, regulations..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-64 bg-gray-100 border border-gray-300 rounded-md py-2 px-4 pl-10 focus:outline-none focus:ring-2 focus:ring-[#3B82F6] focus:border-transparent"
          />
          <Search className="h-5 w-5 text-gray-400 absolute left-3 top-2.5" />
        </form>
        */}
      </div>

      <div className="flex items-center space-x-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={handleNotificationsClick}
          className="relative p-1 text-gray-600 hover:text-gray-900 focus:outline-none"
        >
          <Bell className="h-6 w-6" />
          <span className="absolute top-0 right-0 h-2 w-2 bg-[#EF4444] rounded-full"></span>
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={handleHelpClick}
          className="p-1 text-gray-600 hover:text-gray-900 focus:outline-none"
        >
          <HelpCircle className="h-6 w-6" />
        </Button>
        <span className="h-6 border-l border-gray-300"></span>
        <UserNav />
      </div>
    </header>
  );
}

export default Header;
